import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import ProfileTab from "./ProfileTab";
import Header from "../../components/header/Header";
import PasswordTab from "./PasswordTab";
import { useAuth } from "../../context/AuthContext";
import "./AccountPage.css";
import ProgramSection from "./sections/ProgramSection";
import SubscriptionSection from "./sections/SubscriptionSection";
import DangerZoneTab from "../../components/dangerZoneTab/DangerZoneTab";
import SwitchAccountTab from "./sections/SwitchAccount/SwitchAccountTab";
import StatusModal from "../../components/modals/statusModal/StatusModal";
import ProfileChecklist from "../../components/profileChecklist/ProfileChecklist";

const VALID_TABS = ["profile", "programs", "switch", "password"];

const AccountPage = () => {
  const [searchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(
    VALID_TABS.includes(requestedTab) ? requestedTab : "profile",
  );
  // Lets other pages (e.g. the dashboard home's profile-completion checklist)
  // deep-link straight to a field via /account?tab=profile&subTab=career,
  // not just the top-level tab.
  const [profileSubTab, setProfileSubTab] = useState(
    requestedTab === "profile" ? searchParams.get("subTab") : null,
  );
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();

  const handleChecklistNavigate = ({ tab, subTab }) => {
    setActiveTab(tab);
    if (tab === "profile" && subTab) setProfileSubTab(subTab);
  };

  const userRole = user?.role;
  const userStatus = user?.userApprovalStatus;

  // ✅ Move statusModal state here so both ProfileTab and SwitchAccountTab can use it
  const [statusModal, setStatusModal] = useState({
    open: false,
    type: "success",
    message: "",
    subtext: "",
  });

  console.log("User :", user);

  return (
    <div className="dashboard-layout">
      <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="dashboard-content">
        {/* Top section */}
        <div className="account-container">
          {/* LEFT SIDE MENU */}
          <div className="account-menu">
            <h3>Account Settings</h3>

            <button
              className={activeTab === "profile" ? "active" : ""}
              onClick={() => setActiveTab("profile")}
            >
              My Profile
            </button>

            {userRole !== "student" && (
              <button
                className={activeTab === "programs" ? "active" : ""}
                onClick={() => setActiveTab("programs")}
              >
                My Programs
              </button>
            )}
            {/* ✅ Add this button */}
            {userStatus === "approved" && (
              <button
                className={activeTab === "switch" ? "active" : ""}
                onClick={() => setActiveTab("switch")}
              >
                Switch Account
              </button>
            )}
            <button
              className={activeTab === "password" ? "active" : ""}
              onClick={() => setActiveTab("password")}
            >
              Password Settings
            </button>
            <button
              className={activeTab === "danger" ? "active" : ""}
              onClick={() => setActiveTab("danger")}
              style={{ color: "#e53935" }} // red tint to signal danger
            >
              Danger Zone
            </button>
          </div>

          <div className="account-main">
            <div className="account-banner">
              <img src="/images/blog-img5.png" alt="banner" />
            </div>

            <ProfileChecklist user={user} onNavigate={handleChecklistNavigate} />

            {activeTab === "profile" && (
              <ProfileTab
                setStatusModal={setStatusModal}
                initialTab={profileSubTab}
              />
            )}
            {userRole !== "student" && activeTab === "programs" && (
              <ProgramSection setStatusModal={setStatusModal} />
            )}
            {/* ✅ Add this render */}
            {activeTab === "switch" && (
              <SwitchAccountTab setStatusModal={setStatusModal} />
            )}
            {activeTab === "password" && <PasswordTab />}
            {activeTab === "danger" && <DangerZoneTab />}
          </div>
        </div>
      </div>

      {/* ✅ Single StatusModal at the top level — visible from any tab */}
      <StatusModal
        open={statusModal.open}
        type={statusModal.type}
        message={statusModal.message}
        subtext={statusModal.subtext}
        onClose={() => setStatusModal((s) => ({ ...s, open: false }))}
      />
    </div>
  );
};

export default AccountPage;
